import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {AVAILABLE_LOCALES, AVAILABLE_LOCALE_NAMES} from 'services/locale/constants';
import {changeLocale} from 'containers/LanguageProvider/actions';
import {Select} from 'components/inputs/Select';
import {WithChangeLocaleForUser} from 'api/users/WithChangeLocaleForUser';


class LanguageToggleUnConnected extends React.Component {
    static propTypes = {
        userId: PropTypes.string,
        locale: PropTypes.string,
        changeLocale: PropTypes.func,
        showText: PropTypes.bool,
        selectProps: PropTypes.object,
        fullWidth: PropTypes.bool
    };

    static defaultProps = {
        selectProps: {}
    };

    handleChange = (option, doChangeLocale) => {
        const locale = option.value;

        if (this.props.userId) {
            doChangeLocale(this.props.userId, locale).then(() => {
                this.props.changeLocale(locale);
            });
        }
        else {
            this.props.changeLocale(locale);
        }
    };

    getPlaceholderForLocale = (locale) => {
        if (this.props.showText) {
            return AVAILABLE_LOCALE_NAMES[locale];
        }

        return locale.toUpperCase();
    };

    getOptions = () => {
        return AVAILABLE_LOCALES.map(locale => ({value: locale, label: this.getPlaceholderForLocale(locale)}));
    };

    render() {

        const options = this.getOptions();
        const selectedOption = options.find(item => item.value === this.props.locale);

        return (
            <WithChangeLocaleForUser>
                {(doChangeLocaleForUser) => (
                    <Select
                        fullWidth={this.props.fullWidth}
                        key={this.props.locale}
                        defaultValue={selectedOption}
                        options={options}
                        onChange={(option) => this.handleChange(option, doChangeLocaleForUser)}
                        {...this.props.selectProps}
                    />
                )}
            </WithChangeLocaleForUser>
        );
    }
}

const mapStateToProps = (state) => ({locale: state.languageProvider.locale});

const mapDispatchToProps = {changeLocale};

export const LanguageToggle = connect(mapStateToProps, mapDispatchToProps)(LanguageToggleUnConnected);

LanguageToggle.propTypes = {
    userId: PropTypes.string,
    showText: PropTypes.bool,
    selectProps: PropTypes.object
};

export default LanguageToggle;
